import PropTypes from "prop-types";

DifferenceItem.propTypes = {
  icon: PropTypes.any.isRequired,
  message: PropTypes.string.isRequired,
  boldText: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  isLarge: PropTypes.bool,
  position: PropTypes.oneOf(["left", "right"]),
  textClass: PropTypes.string,
  iconClass: PropTypes.string,
  wrapperClass: PropTypes.string,
};

export default function DifferenceItem({
  icon,
  message,
  boldText,
  amount,
  isLarge = false,
  position = "right",
  textClass = "",
  iconClass,
  wrapperClass,
}) {
  const splitMessage = message.split(boldText);

  return (
    <div
      className={`flex relative ${position === "right" ? "flex-row" : "flex-row-reverse"}  items-center ${isLarge ? `justify-center ${wrapperClass}` : wrapperClass}`}
    >
      <img
        src={icon}
        alt={message}
        className={`${isLarge ? (iconClass ?? "max-w-96") : (iconClass ?? "max-w-28")}`}
      />
      <div className="flex-grow lg:flex-grow-0" />
      <div className={`${textClass || "ml-4"}`}>
        <h1 className="text-4xl font-bold">${amount}</h1>
        <p className="text-lg break-normal max-w-48 ">
          {splitMessage[0]}
          <b>{boldText}</b>
          {splitMessage[1]}
        </p>
      </div>
    </div>
  );
}
